import React, {useState} from 'react';
import { CockpitProvider } from './CockpitContext';
import GeneralView from './GeneralView';
import ChannelView from './ChannelView';
import  SurveysModal  from 'components/Auth/Modals/SurveysHome';

import { Container, GeneralContent, Content, Separator } from './styles';

const Cockpit: React.FC = () => {
  const [surveysModalCheck, setSurveysModalCheck] = useState(true);

  return (
    <>
      <SurveysModal
        isOpen={surveysModalCheck}
        onRequestClose={() => setSurveysModalCheck(false)}
      />
      <CockpitProvider>
        <Container>
          <GeneralContent>
            <Content>
              <h3>Cockpit - Visão Geral</h3>
              <GeneralView />
            </Content>
          </GeneralContent>
          <Content>
            <Separator />
            <ChannelView />
          </Content>
        </Container>
      </CockpitProvider>
    </>
  );
};

export default Cockpit;
